/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function ProviderTableConfig($translate, $mdDialog, $document, $state, toast, types, utils, userService, providerService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(/*params*/) {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;
        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.provider,

            tableTitle: $translate.instant('provider.providers'),

            columns: [
                { key: 'createdTime',
                  title: 'entity.createdTime'},
                { key: 'title',
                  title: 'provider.title'},
                { key: 'netId',
                  title: 'provider.net-id'},
                { key: 'providerSubscriptionName',
                  title: 'subscription.subscription'},
                { key: 'country',
                  title: 'contact.country'},
                { key: 'city',
                  title: 'contact.city'},
                { key: 'customersCount',
                  title: 'provider.customers-count'},
                { key: 'gatewaysCount',
                  title: 'provider.gateways-count'},
                { key: 'devicesCount',
                  title: 'provider.devices-count'}
            ],

            loadEntities: () => {return providerService.getProviders()},
            loadEntity: (entityId) => {return providerService.getProvider(entityId)},
            saveEntity: (entity) => {return providerService.saveProvider(entity)},
            deleteEntity: (entityId) => {return providerService.deleteProvider(entityId)},

            manageUsers: (event, entity) => {
                manageUsers(event, entity);
            },
            actionCellDescriptors: [
                {
                    name: 'provider.manage-users',
                    icon: 'account_circle',
                    isEnabled: () => {
                        return true;
                    },
                    onAction: ($event, entity) => {
                        manageUsers($event, entity);
                    }
                }
            ],
            detailsReadOnly: () => {
                return access == types.access.user;
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('provider.delete-provider-title', {title: entity.title});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('provider.delete-provider-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('provider.delete-providers-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('provider.delete-providers-text');
            }

        };

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function manageUsers($event, provider) {
        if ($event) {
            $event.stopPropagation();
        }
        $state.go('home.providers.users', {providerId: provider.id.id});
    }

}



// WEBPACK FOOTER //
// ./src/app/provider/provider-table.config.js